import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import TagItem from "./TagItem";
import TextButton from "../common/TextButton";
var TagsList = function TagsList(_ref) {
  var customFields = _ref.customFields,
    patientTags = _ref.patientTags,
    _ref$maxVisibleTags = _ref.maxVisibleTags,
    maxVisibleTags = _ref$maxVisibleTags === void 0 ? 4 : _ref$maxVisibleTags,
    onToggleTags = _ref.onToggleTags,
    _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var mappedTags = useMemo(function () {
    return patientTags.reduce(function (acc, curr) {
      var field = customFields === null || customFields === void 0 ? void 0 : customFields.find(function (f) {
        return f.id === Number(curr.tag_id);
      });
      if (!field || !field.additional.isEnabled) return acc;
      return [].concat(_toConsumableArray(acc), [{
        tagData: curr,
        field: field
      }]);
    }, [])
    // Sort by updated_at in descending order (most recent first)
    .sort(function (a, b) {
      return new Date(b.tagData.updated_at).getTime() - new Date(a.tagData.updated_at).getTime();
    });
  }, [patientTags, customFields]);

  // Get visible tags (first 6 most recent) and count of remaining
  var visibleTags = useMemo(function () {
    return mappedTags.slice(0, maxVisibleTags);
  }, [mappedTags, maxVisibleTags]);
  var remainingCount = useMemo(function () {
    return Math.max(0, mappedTags.length - maxVisibleTags);
  }, [mappedTags, maxVisibleTags]);
  return visibleTags.length ? /*#__PURE__*/React.createElement("div", {
    className: classNames("flex flex-wrap gap-3")
  }, visibleTags.map(function (_ref2) {
    var tagData = _ref2.tagData,
      field = _ref2.field;
    return /*#__PURE__*/React.createElement("div", {
      key: field.id,
      className: "flex flex-wrap gap-3 items-center"
    }, /*#__PURE__*/React.createElement(TagItem, {
      key: field.id,
      field: field,
      value: tagData.response,
      isEditing: false,
      disableEditing: true,
      onEdit: function onEdit() {},
      onSave: function onSave() {},
      onCancel: function onCancel() {},
      onValueChange: function onValueChange() {},
      onRemove: function onRemove() {}
    }));
  }), remainingCount > 0 && /*#__PURE__*/React.createElement(TextButton, {
    onClick: onToggleTags,
    className: "px-2.5 py-1 capitalize font-medium"
  }, isExpanded ? t("collapse") : t("view_all"))) : null;
};
export default TagsList;